import React from "react";
import graph from "../assets/bitcoingraph.webp";
import "../style/graphgif.css";

const graphGif = () => {
return(
<div className="wrapper">
    <div className="left"> <h1 className="title">Explore The Future of Digital Finance</h1>
    <p className="ptag">VaultX Crypto is the easiest, safest, and fastest way to see & monitor crypto news.
</p>
<button className="buttontag">Explore News</button>
    </div>
<div className="right">
    <img src={graph} alt="Graph Gif" className="gif"/>
</div>

</div>
);
}
export default graphGif;